import { Upload, Zap, FileVideo, ArrowDown } from "lucide-react";

export const HeroSection = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('upload-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-16 pb-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto text-center">
        {/* Animated Icon */}
        <div className="mb-8 inline-flex items-center justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-primary/20 rounded-2xl blur-xl animate-pulse-soft" />
            <div className="relative p-4 bg-gradient-to-br from-primary to-accent rounded-2xl shadow-lg">
              <Upload className="h-8 w-8 text-primary-foreground" strokeWidth={2} />
            </div>
          </div>
        </div>

        {/* Main Headline */}
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground tracking-tight mb-6 opacity-0 animate-fade-up" style={{ animationDelay: '0.1s' }}>
          Upload Your Video
          <span className="block mt-2 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            for Processing
          </span>
        </h1>

        {/* Subheadline */}
        <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed opacity-0 animate-fade-up" style={{ animationDelay: '0.2s' }}>
          Submit your Google Drive link and we'll compress, split, and prepare your video automatically.
        </p>

        {/* Feature Pills */}
        <div className="flex flex-wrap items-center justify-center gap-3 mb-12 opacity-0 animate-fade-up" style={{ animationDelay: '0.3s' }}>
          <FeaturePill icon={<FileVideo className="h-4 w-4" />} text="Video Processing" />
          <FeaturePill icon={<Zap className="h-4 w-4" />} text="Fast Delivery" />
          <FeaturePill icon={<Upload className="h-4 w-4" />} text="Easy Upload" />
        </div>

        {/* Scroll Indicator */}
        <button 
          onClick={scrollToForm}
          className="inline-flex flex-col items-center gap-2 text-muted-foreground hover:text-primary transition-colors duration-300 opacity-0 animate-fade-up"
          style={{ animationDelay: '0.4s' }}
        >
          <span className="text-sm font-medium">Get Started</span>
          <ArrowDown className="h-5 w-5 animate-bounce" />
        </button>
      </div>
    </section>
  );
};

const FeaturePill = ({ icon, text }) => (
  <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-card border border-border/60 shadow-sm hover:shadow-md hover:border-primary/30 transition-all duration-300">
    <span className="text-primary">{icon}</span>
    <span className="text-sm font-medium text-foreground">{text}</span>
  </div>
);
